import React from "react";
import { Container, H1_SIZE } from "../home/ui";

// Hero artwork (support agent with headset, chat / mail / phone bubbles). On desktop (lg+) it sits on the right
// side of the section; on mobile it shows below the text.
// File: public/img/contact-hero.jpg (cropped from the design mockup; swap in a high-res export when available).
const heroImg = "/img/contact-hero.jpg";

const fadeX = "linear-gradient(to right, transparent 0%, #000 14%, #000 96%, transparent 100%)";
const fadeY = "linear-gradient(to bottom, transparent 0%, #000 8%, #000 92%, transparent 100%)";
const edgeFade = {
  WebkitMaskImage: `${fadeX}, ${fadeY}`,
  WebkitMaskComposite: "source-in",
  maskImage: `${fadeX}, ${fadeY}`,
  maskComposite: "intersect",
};

const ContactHero = () => (
  <section className="relative overflow-hidden bg-gradient-to-r from-[#FBFCFE] via-[#F7F9FF] to-[#EEF3FE] pb-[40px] pt-[110px] lg:pb-[56px] xl:pt-[calc(clamp(76px,5.83vw,112px)+32px)]">
    <Container className="relative grid max-w-[1320px] items-center gap-[24px] lg:grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)]">
      <div className="m-hero">
        <span className="inline-flex items-center rounded-full bg-[#E3EDFF] px-[16px] py-[6px] text-[13px] font-semibold uppercase tracking-[0.04em] text-[#1E4DFF]">
          Contact Us
        </span>

        <h1 className={`mt-[18px] font-extrabold tracking-tight text-[#0B1A4A] ${H1_SIZE}`}>
          Let&apos;s Build Something
          {" "}<br />
          <span className="text-[#1E6BFF]">Great</span> Together
        </h1>

        <p className="mt-[18px] max-w-[560px] text-[16px] leading-[1.6] text-slate-600 sm:text-[17px] xl:text-[clamp(15px,1.05vw,19px)]">
          Have a project in mind or need support? We&apos;re here to help. Get in touch with our team and we&apos;ll get back to
          you as soon as possible.
        </p>
      </div>

      <div className="flex justify-center lg:justify-end">
        <img
          src={heroImg}
          alt="Support executive with a headset ready to help"
          className="h-auto w-full max-w-[520px] select-none object-contain"
          style={edgeFade}
        />
      </div>
    </Container>
  </section>
);

export default ContactHero;
